/*
  userInfo.js-是vuex的一个module.
*/
const state = {
  eduStudentId: '',
  gender: '',
  headerUrl: '',
  nickName: '',
  phone: '',
  studentHeaderUrl: '',
  studentNickName: '',
  studentRealName: '',
  userId: '',
  userType: ''
}

const getters = {
  isLogin (state) {
    const { userId } = state
    return userId !== null && userId !== undefined && userId !== ''
  }
}

const mutations = {
  SET_USER_INFO (state, data) {
    const { eduStudentId, gender, headerUrl, nickName, phone, studentHeaderUrl, studentNickName, studentRealName, userId, userType } = data
    state.eduStudentId = eduStudentId
    state.gender = gender
    state.headerUrl = headerUrl
    state.nickName = nickName
    state.phone = phone
    state.studentHeaderUrl = studentHeaderUrl
    state.studentNickName = studentNickName
    state.studentRealName = studentRealName
    state.userId = userId
    state.userType = userType
  }
}
// 异步操作
const actions = {
  // 用户信息监测
  initUserInfo ({ commit }, data) {
    commit('SET_USER_INFO', data)
  }
}
export default { namespaced: true, state, getters, mutations, actions }
